import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FormArray, FormGroup } from '@angular/forms';
import { Observable, of, Subject } from 'rxjs';
import { catchError, takeUntil ,map} from 'rxjs/operators';
import { RankGrade, LookupApi } from 'src/app/core/api.gen';

@Component({
  selector: 'app-grade-select',
  templateUrl: './Searchable-select.component.html',
  styleUrls: ['./Searchable-select.component.css'],
})
export class SearchableSelectComponent extends FieldType implements OnInit, OnDestroy {
  grades$: Observable<RankGrade[]> = of([]);
  private destroy$ = new Subject<void>();

  constructor(private lookupApi: LookupApi) {
    super();
  }
  get fc() {
    return this.formControl;
  }
  ngOnInit(): void {
    const root: any = this.form?.root ?? this.form;
    const normalizeValue = (v: any) =>typeof v === 'object' && v !== null  ? Object.values(v)[0]  : v;
    const toInt = (v: any): number => {
    const n = Number(normalizeValue(v));
    return Number.isFinite(n) ? n : 0;
    };
    const toStringValue = (v: any): string =>normalizeValue(v)?.toString().trim() ?? '';
    const getStepGroups = (): FormGroup[] => {
      if (root instanceof FormArray) {
        return root.controls.filter((c: any) => c instanceof FormGroup) as FormGroup[];
      }
      const ctrls = root?.controls;
      if (ctrls && typeof ctrls === 'object') {
        return Object.keys(ctrls)
          .map((k) => ctrls[k])
          .filter((c: any) => c instanceof FormGroup) as FormGroup[];
      }
      return root instanceof FormGroup ? [root] : [];
    };
   const findValue = (paths: string[]) => {
    for (const path of paths) {
    for (const g of getStepGroups()) {
      const c = g.get(path);
      if (c && c.value != null && c.value !== '') {
        return c.value;
      }
    }
  }
  return undefined;
};

let prevRank = '';
let prevSlId = 0;
let prevCountryId = 0;
let firstLoad = true;

const load = () => {
  const rank = toStringValue(findValue(['job.rank']));
  const slId = toInt(findValue(['serviceLine.id']));
  const countryId = toInt(findValue(['officeLocationCountry.id']));
  const parentChanged =
    (!firstLoad) &&
    (rank !== prevRank || slId !== prevSlId || countryId !== prevCountryId);

  if (parentChanged) {
    this.formControl?.setValue(null, { emitEvent: false });
    this.formControl?.markAsPristine();
    this.formControl?.markAsUntouched();
    this.formControl?.updateValueAndValidity({ emitEvent: false });
  }
  prevRank = rank;
  prevSlId = slId;
  prevCountryId = countryId;
  firstLoad = false;
  if (rank && slId > 0 && countryId > 0) {
    this.grades$ = this.lookupApi.getGrades(rank, slId, countryId).pipe(
      map(grades =>
        (grades || []).slice().sort((a, b) =>
          (a.grade_Descr || '').localeCompare(b.grade_Descr || '', undefined, {
            numeric: true,
            sensitivity: 'base',
          })
        )
      ),
      catchError(() => of([]))
    );
  } else {
    this.grades$ = of([]);
  }
};
    load();
    (root?.valueChanges ?? this.form?.valueChanges)
      ?.pipe(takeUntil(this.destroy$))
      ?.subscribe(load);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
